import request from '@/utils/request'

let Supply_productApi = {

  /*产品服务列表*/
  list(data) {
    return request._post('/shop/plus.supply_product.Index/index', data);
},
/*添加产品服务*/
add(data) {
    return request._post('/shop/plus.supply_product.Index/add', data);
},
/*修改产品服务*/
edit(data) {
    return request._post('/shop/plus.supply_product.Index/edit', data);
},
/*删除产品服务*/
del(data) {
    return request._post('/shop/plus.supply_product.Index/del', data);
},
/*产品服务详情*/
detail(data) {
  return request._post('/shop/plus.supply_product.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.supply_product.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.supply_product.Setting/getSetting', data, errorback);
    },
}
export default Supply_productApi;



// WEBPACK FOOTER //
// ./src/api/supply_product.js